import * as constants from './actions';

import { getInitiatedTime } from '../../utils/actionTiming';

const initialState = {};

export default function link(state = initialState, { type, payload }) {
    switch (type) {
        case constants.LINK_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state)
            };
        case constants.LINK_SUCCESS:
            return {
                ...state,
                completeLink: payload,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier]
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Link/reducer.js